import {Sound} from '../../../shared/scripts/Sound'
import {UIReplayShareButton} from '../../../shared/scripts/ui_replay/elements/UIReplayShareButton'
import {UIMDeviceHandler} from '../ui_html/UIMDeviceHandler'

export class UIMReplayShareButton extends UIReplayShareButton {
    protected async shareReplay(): Promise<void> {
        const shareableLink = await this.getShareableLink()
        if(shareableLink === undefined) return

        Sound.playSound(Sound.SoundType.Click)
        const url = new URL(shareableLink)
        UIMDeviceHandler.sendShareLink(url.href)
    }
}
